import React from 'react';
import { useDispatch } from 'react-redux';
import { listProjectActivities } from '../../../redux/actions/activity';
import { hideModal } from '../../../redux/actions/modal';
import text from '../../../text';
import { Modal } from 'react-bootstrap';
import { UploadAssetForm } from './form';
export var UPLOAD_ASSET_MODAL = 'UPLOAD_ASSET_MODAL';
var UploadAssetModal = function(param) {
    var show = param.show, projectId = param.projectId;
    var dispatch = useDispatch();
    var onHide = function() {
        return dispatch(hideModal(UPLOAD_ASSET_MODAL));
    };
    var onSubmit = function() {
        dispatch(listProjectActivities(projectId));
        onHide();
    };
    return /*#__PURE__*/ React.createElement(Modal, {
        centered: true,
        show: show,
        onHide: onHide
    }, /*#__PURE__*/ React.createElement(Modal.Header, {
        closeButton: true
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "secondary"
    }, text('uploadFiles'))), /*#__PURE__*/ React.createElement(UploadAssetForm, {
        projectId: projectId,
        onSubmit: onSubmit,
        onCancel: onHide
    }));
};
export default UploadAssetModal;
